/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { useDispatch } from "react-redux";
import success from "../../../assests/images/SVG/success@2x.svg";
import booking_details from "../../../assests/images/booking_details.svg";
import whatsapp from "../../../assests/images/whatsapp.svg";
import { clearUpdateShipment } from "../../../actionsMethods/cashBookingMethods";
import axios from "axios";
import { useSelector, shallowEqual } from "react-redux";
import "./index.scss";
const Alert = ({ alertData, allData, clearFunction }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { fetching, result, error } = useSelector(
    (state) => state.appReducer.getBarcodeIdReducer,
    shallowEqual
  );
  const chidlPacketIdsResponse = useSelector(
    (state) => state.appReducer.getChildPacketIdsReducer
  );

  const { error: childIdsError, result: childIdsResult } =
    chidlPacketIdsResponse;

  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    setIsModalOpen(alertData?.visible);
    // setTimeout(() => {
    //   setIsModalOpen(false);
    //   dispatch(clearUpdateShipment());
    // }, 3000);
    recieverSms();
    senderSms();
  }, [alertData]);

  const handleCancel = () => {
    clearFunction();
    setIsModalOpen();
    dispatch(clearUpdateShipment());
  };

  const senderSms = async () => {
    try {
      let res = await axios.get(
        `https://pgapi.vispl.in/fe/api/v1/send?username=shremotpg.trans&password=uNIvT&unicode=false&from=SMCSPL&dltPrincipalEntityId=1001569800000012636&dltContentId=1007163186467531163&text=Shree Maruti Courier
        Your shipment ${result?.data?.awbNumber} is booked with Shree Maruti Courier. To track your shipment you can visit https://www.shreemaruticourier.com/tracking/?d=${result?.data?.awbNumber}&to=${allData?.values?.mobileNumber}`
      );
      if (res.data) {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const recieverSms = async () => {
    try {
      let res = await axios.get(
        // eslint-disable-next-line max-len
        `http://wa3.nuke.co.in/admin/sendwhatsapp/insert_whatsapp_api1?username=maruticourier&password=*********&mobile_no=${allData?.addressDetails?.senderMobileNumber}&message=message_to_consigner_while_cash_booking_ft_vp_service_v2_2&uploaded1=whatsapp/2023-01-02_09:53:33842368-cash-invoice.pdf&uploaded2=FastTrack&uploaded3=${result?.data?.awbNumber}&uploaded4=ASF&uploaded5=DELHI&uploaded6=https://www.shreemaruti.com/dw/?a=R98s3K&uploaded7=https://www.shreemaruti.com/dw/?a=S79s3P&uploaded9=tracking/?d=${result?.data?.awbNumber}`
      );

      if (res.data) {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={isModalOpen}
      width={600}
      header={null}
      footer={null}
      closable={true}
      destroyOnClose={true}
      onCancel={handleCancel}
      className="alert-class"
    >
      <img src={success} className="alert-image" />
      <p className="alert-message">{alertData?.message}</p>
      <p className="order-id">
        for Order Id:&nbsp;{" "}
        <span style={{ paddingBottom: "1px" }}>{result?.data?.awbNumber}</span>
      </p>
      {/* <p style={{ display: "inline" }}>
        {mydata.map((item) => item.name).join(", ")}
      </p> */}
      {childIdsResult !== null ? (
        <p style={{ paddingTop: "10px" }}>
          for Child Packet Id:&nbsp;{" "}
          <span>{childIdsResult.map((e, i) => e?.awbNumber).join(", ")}</span>
        </p>
      ) : (
        ""
      )}

      <div style={{ paddingTop: "15px" }}>
        <div
          style={{ display: "flex", justifyContent: "center" }}
          className="booking_invoice_details"
        >
          <img src={booking_details} />
          <p style={{ margin: 0 }}>
            &nbsp;&nbsp;Booking details sent to {allData?.values?.mobileNumber}
            &nbsp;
          </p>
        </div>
        <div
          style={{ display: "flex", justifyContent: "center" }}
          className="booking_invoice_details"
        >
          <img src={whatsapp} />

          <p style={{ margin: 0 }}>
            &nbsp; Invoice details sent to{" "}
            {allData?.addressDetails?.senderMobileNumber}
            &nbsp;
          </p>
        </div>
      </div>

      {/* <div className={deactivate}>
        {!status ? (
          <>

          </>
        ) : (
          <>
            <img src={warning} />
            <p>&nbsp;Failed to send booking information.&nbsp;</p>
            <a>resend</a>
          </>
        )}
      </div> */}
      {/* <div className={`${deactivate} invoice-details`}>
        {!status ? (
          <>
            <img src={whatsapp} />

            <p>
              &nbsp; Invoice details sent to {id?.receiverMobilenumber}
              &nbsp;
            </p>
          </>
        ) : (
          <>
            <img src={warning} />
            <p>&nbsp;Failed to send booking information.&nbsp;</p>
            <a>resend</a>
          </>
        )}
      </div> */}
    </Modal>
  );
};
export default Alert;
